document.addEventListener('DOMContentLoaded', function () {
  // ======= START: append size chart Start ==============
  var moveSizeGuideInterval = setInterval(function () {
    var variantColorDetail = document.querySelector('.g-variant-color-detail');
    var sizeGuide = document.querySelector('.size-guide-container');
  
    if (variantColorDetail && sizeGuide) {
      // Move size guide after .g-variant-color-detail
      variantColorDetail.parentNode.insertBefore(sizeGuide, variantColorDetail.nextSibling);
      
      // Stop the interval
      clearInterval(moveSizeGuideInterval);
    }
  }, 100); // checks every 300ms
  
   // ======= END: append size chart Start ==============

   // ======= START: Trigger size chart tab ==============
  // const sizeGuideTitle = document.querySelector('.size-guide-title');
  // const sizeGuideDetails = document.querySelector('.size-guide-tab');
  
  // if (sizeGuideTitle && sizeGuideDetails) {
  //   const summary = sizeGuideDetails.querySelector('summary');
  
  //   sizeGuideTitle.addEventListener('click', function (e) {
  //     e.preventDefault();
  
  //     // Scroll smoothly to the title
  //     sizeGuideTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
  //     // After scroll finishes
  //     setTimeout(function () {
  //       // Only click if not already open
  //       if (!sizeGuideDetails.hasAttribute('open')) {
  //         summary.click(); // Trigger open
  //       }
  //     }, 800);
  //   });
  // }
   // ======= END: Trigger size chart tab ==============

  // Review append Code Start
  
  let originalParent, originalNext;
  
  function moveReviewBadge() {
    const badge = document.querySelector('.jdgm-widget');
    const target = document.querySelector('.price-title-show-mobile');
    if (!badge || !target) return;
  
    if (!originalParent) {
      originalParent = badge.parentNode;
      originalNext = badge.nextElementSibling;
    }
  
    if (window.innerWidth <= 749) {
      if (target.previousElementSibling !== badge) target.before(badge);
    } else {
      if (badge.parentNode !== originalParent) {
        originalParent.insertBefore(badge, originalNext || null);
      }
    }
  }
  moveReviewBadge();
  window.addEventListener('resize', moveReviewBadge);
  
  // Review append Code End



  function updateReviewText() {
  const badge = document.querySelector('.jdgm-prev-badge__text');
  if (!badge) return false;

  // Force the exact copy the client wants
  badge.textContent = 'Rated 5/5 By Runners in 15 Countries';

  // Optional: clean up any leftover siblings (like the native “X reviews” count)
  let next = badge.nextSibling;
  while (next) {
    const toRemove = next;
    next = next.nextSibling;
    toRemove.remove();
  }

  return true;
}

// Retry until badge is on the page
const checkInterval = setInterval(() => {
  if (updateReviewText()) {
    clearInterval(checkInterval);
  }
}, 1500);
});

